import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form8 = (record: any) => {
  return {
    departmentCode: "2",
    aflType: AFLType.MaternityLeaveApplication,
    layout: [
      {
        type: "header",
        value: {
          form: 2,
          department: StringHelper.verticalBarSplit(record?.eDepartment)[1],
        },
      },
      { type: "title", value: { sub: [] } },
      {
        type: "salutation",
        value: [
          "- Trưởng phòng/trung tâm",
          "- Trưởng phòng Tổ chức hành chính.",
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          { type: "eEmployeeId", value: record?.eEmployeeId },
          {
            type: "eWorkPlace",
            value: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
          },
          {
            type: "",
            value:
              "Nay tôi kính thông báo đến Trưởng phòng/trung tâm về việc tôi sẽ nghỉ thai sản với thời gian như sau:",
          },

          {
            type: "eVacationPeriodNoCount",
            value: record?.eVacationPeriod,
          },
          {
            type: "eExpectedReturnDate",
            value: record?.eExpectedReturnDate,
          },
          { type: "eReason", value: record?.eReason || "" },
          {
            type: "",
            value:
              "Rất mong nhận được sự chấp thuận của Trưởng phòng/trung tâm",
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: [
              "- Như trên;",
              "- TCHC (để biết);",
              "- Lưu: phòng/trung tâm. ",
            ],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA TRƯỞNG PHÒNG/TRUNG TÂM",
              record?.eApprovalProcess[4][0].name,
            ],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
